import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import levendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import stegvisVideo from '@nrk/dh-basis-stegvis-video'
import './init-sentry.ts'
import './lib/scroll-timeline.js'
import { Poll } from './components/content/cards/poll.js'
import { CopyLink } from './components/content/cards/copy-link.ts'

import '@nrk/core-design-tokens/dist/color/nrk-color-tokens.css'

// TODO: Styles are used only when rendering on server side. Need to improve how css is generated
// import './components/app.html'
import './components/app.module.css'
import './components/card-section.module.css'
import './components/content/main-content.module.css'
import './components/content/main-content-theme.module.css'
import './components/content/main-content-padding.module.css'
import './components/content/cards/shared/card.module.css'
import './components/content/cards/colophon.module.css'
import './components/content/cards/intro.module.css'
import './components/content/cards/cover.module.css'
import './components/content/cards/header.module.css'
import './components/content/cards/text.module.css'
import './components/content/cards/quote.module.css'
import './components/content/cards/alt-text.module.css'
import './components/content/cards/poll.module.css'
import './components/content/media/fullscreen/media-fullscreen.module.css'
import './components/content/media/fullscreen/video.module.css'
import './components/content/media/shared/gradient.module.css'
import './components/content/media/shared/object-fit.module.css'
import './components/content/media/shared/text-position.module.css'
import './components/content/media/shared/scroll-progress.module.css'
import './components/content/media/square/media-square.module.css'
import './components/content/media/background.module.css'
import './components/content/media/background-sticky.module.css'

import { CardSection } from './components/card-section.js'
import { KortstokkApp } from './components/app.js'

import { createTracker } from '@nrk/dh-snowplow'
import { EventSchema } from '@nrk/snowplow-web'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends HTMLElement {
  name = tag
  _previousInteraction

  connectedCallback() {
    this.#defineCustomElements()
    this.#createTracker()
    this.addEventListener('dh-basis-scrollhistorie-trigger-activated', this.#handleActiveChanged)
    this._previousInteraction = Date.now()

    this.addEventListener('dh-basis-scrollhistorie-trigger-activated', (e) => {
      e.preventDefault()
      const currentTime = Date.now()
      // const timeElapsedMs = currentTime - this._previousInteraction
      this._previousInteraction = currentTime

      // const sectionElement = e.target
      // const sectionIndex = sectionElement.getAttribute('section-index')
      // const eventLabel = `${sectionIndex}-${e.detail.triggerIndex}`
      // this.sendGaEvent({ eventAction: 'TRIGGER-ACTIVATED', eventLabel, eventValue: timeElapsedMs })
    })

    this.addEventListener('dh-kortstokk-click-navigation', () => {
      if (!this.usedClickNavigation) {
        this.usedClickNavigation = true
        // this.sendGaEvent({ eventAction: 'USED-NAVIGATION-METHOD', eventLabel: 'click' })
      }
    })

    this.addEventListener('dh-kortstokk-keyboard-navigation', () => {
      if (!this.usedKeyboardNavigation) {
        this.usedKeyboardNavigation = true
        // this.sendGaEvent({ eventAction: 'USED-NAVIGATION-METHOD', eventLabel: 'keyboard' })
      }
    })

    this.addEventListener('dh-kortstokk-button-navigation', () => {
      if (!this.usedButtonNavigation) {
        this.usedButtonNavigation = true
        // this.sendGaEvent({ eventAction: 'USED-NAVIGATION-METHOD', eventLabel: 'buttons' })
      }
    })
  }

  disconnectedCallback() {
    this.removeEventListener('dh-basis-scrollhistorie-trigger-activated', this.#handleActiveChanged)
  }

  async #defineCustomElements() {
    // this.sendGaEvent({ eventAction: `MOUNT:${tag}` })

    safeDefine('kortstokk-app', KortstokkApp)
    safeDefine('card-section', CardSection)
    safeDefine('dh-vh-basis-levende-stillbilde', levendeStillbilde)
    safeDefine('dh-vh-basis-stegvis-video', stegvisVideo)
    safeDefine('dhks-poll', Poll)
    safeDefine('dh-copy-link', CopyLink)

    if (
      this.features.video &&
      (typeof customElements.get('dhks-article-player') === 'undefined' ||
        typeof customElements.get('dhks-video') === 'undefined')
    ) {
      const { AutoplayOnActivePlayerElement, Video } = await import(
        './components/content/media/fullscreen/video.ts' /* webpackChunkName: "dhks-video" */
      )
      safeDefine('dhks-article-player', AutoplayOnActivePlayerElement)
      safeDefine('dhks-video', Video)
    }

    if (this.features.lottie && typeof customElements.get('dh-ks-stegvis-lottie') === 'undefined') {
      const stegvisLottie = (
        await import('@nrk/dh-basis-stegvis-lottie' /* webpackChunkName: "dh-stegvis-lottie" */)
      ).default

      safeDefine('dh-ks-stegvis-lottie', stegvisLottie)
    }

    if (this.features.kart && typeof customElements.get('dhk-basis-kart') === 'undefined') {
      const kart = (
        await import('./lib/karthistorie-chunk.js' /* webpackChunkName: "dh-karthistorie" */)
      ).default

      safeDefine('dhk-basis-kart', kart)
    }
  }

  #createTracker() {
    if (process.env.DEV) {
      import('@nrk/dh-snowplow/mock').then(({ mock }) => mock()).catch(console.error)
    }

    this.tracker = createTracker('dh-kortstokk', {
      environment: process.env.ENVIRONMENT,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #handleActiveChanged = (e) => {
    this.tracker.trackSelfDescribingEvent({
      schema: EventSchema.StepEvent,
      data: {
        current: e.detail.triggerIndex + 1,
        total: this.#allCards.length,
      },
    })
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }

  get #allCards() {
    return this.querySelectorAll('[data-show-background]')
  }
}

safeDefine(tag, AppElement)
